import React, { Component } from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { isSameDay } from 'date-fns'
import { DatePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { FormControlLabel, FormLabel, Switch } from '@mui/material'
import { isEqual } from 'lodash-es'
import dayjs from 'dayjs'

/**
 * Date picker component with integrated check box that sets value to "1970-01-01T00:00:00.000Z" when checked
 * uiType must be 'date' in the json schema for this component to render
 */
const isEpoch = (value) => isSameDay(Date.parse(value), new Date(0))

class MaterialDateField extends Component {
    state = {
        checked: false,
        // The last real date the field held, so turning All Time off can
        // put it back.
        previousDate: undefined,
    }

    handleCheckbox = (stateName) => (ev) => {
        this.setState({ [stateName]: ev.target.checked })
    }

    componentDidMount() {
        if (isEpoch(this.props.data)) {
            this.setState({ checked: true })
        } else if (this.props.data) {
            this.setState({ previousDate: this.props.data })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // Connect date to relevant checked state
        if (!isEqual(prevProps.data, this.props.data)) {
            if (isEpoch(this.props.data)) {
                this.setState({ checked: true })
            } else if (this.props.data) {
                this.setState({ checked: false, previousDate: this.props.data })
            } else {
                this.setState({ checked: false })
            }
        }

        // Connect checked state to relevant date
        if (!isEqual(prevState.checked, this.state.checked)) {
            if (this.state.checked) {
                this.props.handleChange(
                    this.props.path,
                    new Date(0).toISOString()
                )
            } else {
                this.props.handleChange(
                    this.props.path,
                    this.state.previousDate ?? new Date().toISOString()
                )
            }
        }
    }

    render() {
        const {
            data,
            handleChange,
            path,
            label,
            enabled,
            uischema,
        } = this.props
        const { checked } = this.state
        return (
            <div>
                <FormLabel component="legend"> {label} </FormLabel>
                <FormControlLabel
                    sx={{ margin: '15px 5px 0 0' }}
                    label={!checked ? 'Sync Since' : 'All Time'}
                    control={
                        <Switch
                            checked={checked}
                            onChange={this.handleCheckbox('checked')}
                            value="checked"
                            disabled={!enabled}
                        />
                    }
                />
                {!checked && (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            // The field clears to null and reports a
                            // part-typed date as invalid; neither is a
                            // date to store.
                            onChange={(value) => {
                                if (value === null) {
                                    handleChange(path, undefined)
                                } else if (value.isValid()) {
                                    handleChange(path, value.toISOString())
                                }
                            }}
                            value={data ? dayjs(data) : null}
                            format="MM/DD/YYYY"
                            disableFuture
                            disabled={!enabled}
                            slotProps={{
                                textField: {
                                    sx: { margin: '7px 0 0 5px' },
                                    // Fills its row unless the uischema
                                    // trims it, as in the stock controls.
                                    fullWidth: !uischema?.options?.trim,
                                },
                            }}
                        />
                    </LocalizationProvider>
                )}
            </div>
        )
    }
}

export default withJsonFormsControlProps(MaterialDateField)
